import React, { lazy, Suspense, useState, useTransition } from 'react';

const CompanyShortlistQuotaModal = lazy(
  () => import('../CompanyShortlistQuotaModal')
);

export default function useCompanyShortlistQuotaModal() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalPending, startTransition] = useTransition();

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const openCompanyShortlistQuotaModal = () => {
    startTransition(() => {
      setIsModalOpen(true);
    });
  };

  return {
    isCompanyShortlistQuotaModalPending: isModalPending,
    companyShortlistQuotaModal: isModalOpen && (
      <Suspense fallback={null}>
        <CompanyShortlistQuotaModal onClose={handleCloseModal} />
      </Suspense>
    ),
    openCompanyShortlistQuotaModal,
  };
}
